import { render, staticRenderFns } from "./PPC2.vue?vue&type=template&id=24b7fee9&scoped=true&"
import script from "./PPC2.vue?vue&type=script&lang=js&"
export * from "./PPC2.vue?vue&type=script&lang=js&"
import style0 from "./PPC2.vue?vue&type=style&index=0&id=24b7fee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7fee9",
  null
  
)

export default component.exports